import { render, staticRenderFns } from "./phreesia.vue?vue&type=template&id=53bae55e&scoped=true&v-once=true"
import script from "./phreesia.vue?vue&type=script&lang=js"
export * from "./phreesia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bae55e",
  null
  
)

export default component.exports